import ABCyaLib from '@abcya/abcya_lib';
import gameData from './gameData';
import Games from './Games';

export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    layout: []
  };
  switch (gameData.game) {
    case Games.alphabet:
      switch (locale) {
        case ABCyaLib.Environment.LOCALES.esUS:
          config.layout = [
            [
              { x: 42,y: 30 },
              { x: 103,y: 13 },
              { x: 165,y: 30 },
              { x: 225,y: 30 },
              { x: 290,y: 30 },
              { x: 44,y: 120 },
              { x: 107,y: 102 },
              { x: 165,y: 120 },
              { x: 217,y: 119 },
              { x: 288,y: 120 },
              { x: 44,y: 210 },
              { x: 81,y: 194 },
              { x: 121,y: 210 },
              { x: 176,y: 210 },
              { x: 240,y: 210 },
              { x: 289,y: 210 },
              { x: 41,y: 307 },
              { x: 119,y: 291 },
              { x: 190,y: 309 },
              { x: 261,y: 293 },
              { x: 44,y: 390 },
              { x: 100,y: 390 },
              { x: 170,y: 390 },
              { x: 237,y: 390 },
              { x: 300,y: 390 },
              { x: 44,y: 482 },
              { x: 110,y: 465 },
              { x: 174,y: 470 },
              { x: 239,y: 487 },
              { x: 38,y: 565 },
              { x: 120,y: 565 },
              { x: 185,y: 565 },
              { x: 250,y: 565 },
            ],
            [
              { x: 34,y: 45 },
              { x: 89,y: 30 },
              { x: 149,y: 35 },
              { x: 205,y: 52 },
              { x: 260,y: 40 },
              { x: 32,y: 116 },
              { x: 89,y: 104 },
              { x: 149,y: 110 },
              { x: 205,y: 131 },
              { x: 260,y: 114 },
              { x: 35,y: 190 },
              { x: 74,y: 190 },
              { x: 107,y: 203 },
              { x: 172,y: 196 },
              { x: 233,y: 197 },
              { x: 274,y: 213 },
              { x: 34,y: 299 },
              { x: 92,y: 283 },
              { x: 157,y: 301 },
              { x: 223,y: 284 },
              { x: 33,y: 374 },
              { x: 88,y: 374 },
              { x: 154,y: 375 },
              { x: 206,y: 376 },
              { x: 266,y: 364 },
              { x: 32,y: 468 },
              { x: 88,y: 452 },
              { x: 149,y: 454 },
              { x: 213,y: 473 },
              { x: 33,y: 547 },
              { x: 104,y: 548 },
              { x: 161,y: 551 },
              { x: 215,y: 551 }
            ],
            [
              { x: 78,y: 67 },
              { x: 147,y: 67 },
              { x: 196,y: 67 },
              { x: 258,y: 67 },
              { x: 76,y: 169 },
              { x: 146,y: 169 },
              { x: 208,y: 169 },
              { x: 76,y: 271 },
              { x: 137,y: 271 },
              { x: 203,y: 271 },
              { x: 78,y: 399 },
              { x: 127,y: 400 },
              { x: 165,y: 399 },
              { x: 210,y: 399 },
              { x: 76,y: 459 },
              { x: 127,y: 460 },
              { x: 172,y: 459 },
              { x: 77,y: 520 },
              { x: 121,y: 519 },
              { x: 169,y: 519 }
            ],
            [
              { x: 30,y: 17 },
              { x: 140,y: 22 },
              { x: 232,y: 17 },
              { x: 25,y: 126 },
              { x: 133,y: 137 },
              { x: 231,y: 141 },
              { x: 42,y: 245 },
              { x: 130,y: 256 },
              { x: 237,y: 260 },
              { x: 51,y: 385 },
              { x: 150,y: 388 },
              { x: 239,y: 384 },
              { x: 48,y: 467 },
              { x: 146,y: 475 },
              { x: 239,y: 478 },
              { x: 58,y: 551 },
              { x: 144,y: 556 },
              { x: 242,y: 561 }
            ],
            [
              { x: 86,y: 130 },
              { x: 126,y: 130 },
              { x: 166,y: 130 },
              { x: 206,y: 130 },
              { x: 65,y: 258 },// comma
              { x: 109,y: 220 },
              { x: 182,y: 213 },
              { x: 233,y: 258 },// period
              { x: 81,y: 322 },
              { x: 158,y: 344 },
              { x: 68,y: 403 },
              { x: 137,y: 400 },
              { x: 217,y: 408 },
            ]
          ];
          break;
        default:
          config.layout = [
            [
              { x: 42,y: 30 },
              { x: 110,y: 30 },
              { x: 165,y: 30 },
              { x: 225,y: 30 },
              { x: 290,y: 30 },
              { x: 44,y: 120 },
              { x: 95,y: 120 },
              { x: 165,y: 120 },
              { x: 245,y: 120 },
              { x: 288,y: 120 },
              { x: 44,y: 210 },
              { x: 105,y: 210 },
              { x: 155,y: 210 },
              { x: 235,y: 210 },
              { x: 296,y: 210 },
              { x: 44,y: 300 },
              { x: 100,y: 300 },
              { x: 180,y: 300 },
              { x: 245,y: 300 },
              { x: 300,y: 300 },
              { x: 44,y: 390 },
              { x: 110,y: 390 },
              { x: 170,y: 390 },
              { x: 44,y: 470 },
              { x: 110,y: 470 },
              { x: 170,y: 470 },
            ],
            [
              { x: 34,y: 45 },
              { x: 88,y: 33 },
              { x: 139,y: 45 },
              { x: 185,y: 33 },
              { x: 237,y: 45 },
              { x: 32,y: 105 },
              { x: 72,y: 115 },
              { x: 126,y: 105 },
              { x: 176,y: 105 },
              { x: 206,y: 105 },
              { x: 35,y: 190 },
              { x: 86,y: 190 },
              { x: 116,y: 203 },
              { x: 180,y: 203 },
              { x: 226,y: 203 },
              { x: 36,y: 270 },
              { x: 86,y: 270 },
              { x: 141,y: 270 },
              { x: 178,y: 270 },
              { x: 219,y: 260 },
              { x: 36,y: 345 },
              { x: 85,y: 345 },
              { x: 130,y: 345 },
              { x: 33,y: 405 },
              { x: 81,y: 405 },
              { x: 129,y: 405 },
            ],
            [
              { x: 78,y: 67 },
              { x: 147,y: 67 },
              { x: 196,y: 67 },
              { x: 258,y: 67 },
              { x: 76,y: 169 },
              { x: 146,y: 169 },
              { x: 208,y: 169 },
              { x: 76,y: 271 },
              { x: 137,y: 271 },
              { x: 203,y: 271 },
              { x: 78,y: 399 },
              { x: 127,y: 400 },
              { x: 165,y: 399 },
              { x: 210,y: 399 },
              { x: 76,y: 459 },
              { x: 127,y: 460 },
              { x: 172,y: 459 },
              { x: 77,y: 520 },
              { x: 121,y: 519 },
              { x: 169,y: 519 }
            ],
            [
              { x: 30,y: 17 },
              { x: 140,y: 22 },
              { x: 232,y: 17 },
              { x: 25,y: 126 },
              { x: 133,y: 137 },
              { x: 231,y: 141 },
              { x: 42,y: 245 },
              { x: 130,y: 256 },
              { x: 237,y: 260 },
              { x: 51,y: 385 },
              { x: 150,y: 388 },
              { x: 239,y: 384 },
              { x: 48,y: 467 },
              { x: 146,y: 475 },
              { x: 239,y: 478 },
              { x: 58,y: 551 },
              { x: 144,y: 556 },
              { x: 242,y: 561 }
            ],
            [
              { x: 46,y: 220 },
              { x: 86,y: 220 },
              { x: 135,y: 258 },
              { x: 169,y: 220 },
              { x: 242,y: 213 },
              { x: 293,y: 258 },
              { x: 81,y: 322 },
              { x: 158,y: 344 },
              { x: 68,y: 403 },
              { x: 137,y: 400 },
              { x: 217,y: 408 }
            ]
          ];
          break;
      }
      break;
    case Games.face:
      switch (locale) {
        default:
          config.layout = [[],[],[],[],[],[],[],[],[]];
          break;
      }
      break;
    case Games.gingerbread:
      switch (locale) {
        default:
          config.layout = [
            [],
            [
              { x: 20,y: 22 },
              { x: 96,y: 22 },
              { x: 21,y: 209 },
              { x: 118,y: 211 },
              { x: 118,y: 278 },
              { x: 118,y: 348 },
              { x: 118,y: 417 },
              { x: 21,y: 429 },
              { x: 127,y: 482 },
              { x: 20,y: 541 }
            ],
            [],
            [],
            [{ x: 16,y: 50 }, { x: 81,y: 100 }, { x: 27,y: 153 }, { x: 57,y: 217 }, { x: 72,y: 322 }, { x: 72,y: 383 }, { x: 72,y: 439 }, { x: 26,y: 492 }, { x: 119,y: 492 }, { x: 75,y: 579 }, { x: 30,y: 660 }, { x: 81,y: 660 }, { x: 132,y: 660 }
            ],
            []
          ];
          break;
      }
      break;
    case Games.pumpkin:
      switch (locale) {
        default:
          config.layout = [[], [], [], [], [], [], [], []];
          break;
      }
      break;
    case Games.snowman:
      switch (locale) {
        default:
          config.layout = [
            [],
            [],
            [],
            [
              { x: 35,y: 13 },
              { x: 15,y: 87 },
              { x: 10,y: 134 },
              { x: 67,y: 182 },
              { x: 22,y: 248 },
              { x: 22,y: 319 },
              { x: 12,y: 416 },
              { x: 94,y: 416 },
              { x: 15,y: 520 },
              { x: 108,y: 520 },
              { x: 26,y: 600 },
              { x: 115,y: 600 },
              { x: 26,y: 664 },
              { x: 118,y: 664 }
            ],
            [
              { x: 33,y: 33 },
              { x: 110,y: 32 },
              { x: 27,y: 165 },
              { x: 120,y: 168 },
              { x: 76,y: 295 },
              { x: 25,y: 428 },
              { x: 49,y: 522 },
              { x: 50,y: 592 },
              { x: 63,y: 634 }
            ]
          ];
          break;
      }
      break;
  }
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
  }
  return config;
}